/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/13/2019.
 */

import * as Fleets from '../../api/Fleets'
import {
    fetchAsset as assetFetchSingleAsset,
    createAssetInGenericFleet as assetsCreateAssetInGenericFleet,
    fetchAssets as assetsFetchAssets
} from "../../api/Assets";

export const CLEAR_STATE = 'CLEAR_STATE'
export const GENERAL_RECEIVE = 'GENERAL_RECEIVE'
export const SET_ASSET_CONFIGURABLE_ATTRIBUTE = 'SET_ASSET_CONFIGURABLE_ATTRIBUTE'
export const SET_ASSET_ATTRIBUTE = 'SET_ASSET_ATTRIBUTE'
export const REQUEST_SUBMIT_ASSET = 'REQUEST_SUBMIT_ASSET';
export const RECEIVE_SUBMIT_ASSET = 'RECEIVE_SUBMIT_ASSET';
export const REQUEST_FLEETS_HIERARCHY = 'REQUEST_FLEETS_HIERARCHY'
export const RECEIVE_FLEETS_HIERARCHY = 'RECEIVE_FLEETS_HIERARCHY'
export const REQUEST_ASSETS = 'REQUEST_ASSETS'
export const RECEIVE_ASSETS = 'RECEIVE_ASSETS'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const REQUEST_ASSET = 'REQUEST_ASSET'
export const RECEIVE_ASSET = 'RECEIVE_ASSET'
export const REQUEST_DELETE_ASSET = 'REQUEST_DELETE_ASSET'

export const REQUEST_ATTRIBUTES = 'REQUEST_ATTRIBUTES'
export const RECEIVE_ATTRIBUTES = 'RECEIVE_ATTRIBUTES'
export const REQUEST_VARIANTS = 'REQUEST_VARIANTS'
export const RECEIVE_VARIANTS = 'RECEIVE_VARIANTS'
export const GENERAL_REQUEST = 'GENERAL_REQUEST'

export const SET_CONFIGURATION_SYMPTOM = 'SET_CONFIGURATION_SYMPTOM'
export const REQUEST_AVAILABLE_CONFIGURATION_SYMPTOMS = 'REQUEST_AVAILABLE_CONFIGURATION_SYMPTOMS'
export const RECEIVE_AVAILABLE_CONFIGURATION_SYMPTOMS = 'RECEIVE_AVAILABLE_CONFIGURATION_SYMPTOMS'

export const createAsset = (asset, isHda) => dispatch => {
    dispatch(requestSubmitAsset());
    if(isHda) {
        return assetsCreateAssetInGenericFleet(asset).then((response) => {
            dispatch(receiveSubmitAsset(response));
            return response
        }).catch(err => {
            dispatch(receiveError(err))
            throw err
        })
    }
    return Fleets.createAsset(asset).then((response) => {
        dispatch(receiveSubmitAsset(response));
        return response
    }).catch(err => {
        dispatch(receiveError(err))
        throw err
    })
}

export const updateAsset = (asset) =>  dispatch => {
    dispatch(requestSubmitAsset())
    return Fleets.updateAsset(asset).then((response) => {
        dispatch(receiveSubmitAsset(response));
        return response
    }).catch(err => {
        dispatch(receiveError(err))
        throw err
    })
}

export const fetchFleetsHierarchy = () => dispatch => {
    dispatch(requestFleetsHierarchy());
    return Fleets.fetchHierarchy(false).then(
        function (response) {
            dispatch(receiveFleetsHierarchy(response))
        }
    );
}

export const fetchAssets = (shallow) => dispatch => {
    dispatch(requestAssets());
    return assetsFetchAssets(shallow).then(
        function (response) {
            dispatch(receiveAssets(response))
        }
    )
}

export const fetchAsset = (assetId) => dispatch => {
    dispatch(requestAsset());
    return assetFetchSingleAsset(assetId).then(
        function (response) {
            dispatch(receiveAsset(response));
        }
    ).catch(err => {
        dispatch(receiveError(err));
    })
}

export const setAssetConfigurableAttribute = (code, property, value) => dispatch => {
    dispatch(setAssetConfigurableAttributeType(code, property, value))
}

export const setAssetAttribute = (key, value) => dispatch => {
    dispatch(setAssetAttributeType(key, value))
}

export const fetchAttributes = (ldiId) => dispatch => {
    dispatch(requestAttributes())
    return Fleets.fetchAttributes(ldiId).then((response) => {
        dispatch(receiveAttributes(response));
        return(response);
    })
}

export const fetchVariants = (ldiId) => dispatch => {
    dispatch(requestVariants())
    return Fleets.fetchVariants(ldiId).then((response) => {
        dispatch(receiveVariants(response));
        return(response);
    })
}

export const fetchAvailableConfigurationSymptoms = (variants, assetId, ldiId) => dispatch => {
    dispatch(requestAvailableConfigurationSymptoms())
    return Fleets.fetchAvailableConfigurationSymptoms(variants, assetId, ldiId).then((response) => {
        dispatch(receiveAvailableConfigurationSymptoms(response));
        return(response);
    })
}

export const deleteAsset = (assetId) => dispatch => {
    dispatch(requestDeleteAsset())
    return Fleets.deleteAsset(assetId).then(
        function (response) {
            dispatch(generalReceiveType())
            return(response);
        }
    ).catch((err) => {
        dispatch(generalReceiveType())
        throw err;
    })
}

export const enableAsset = (assetId) => dispatch => {
    dispatch(generalRequestType())
    return Fleets.enableAsset(assetId).then(
        function (response) {
            dispatch(receiveAsset(response))
            return (response);
        }
    ).catch(() => {
        dispatch(generalReceiveType())
    })
}

const generalRequestType = () => {
    return {
        type: GENERAL_REQUEST,
    }
}

const requestDeleteAsset = () => {
    return {
        type: REQUEST_DELETE_ASSET,
    }
}

const requestAttributes = () => {
    return {
        type: REQUEST_ATTRIBUTES,
    }
}

const requestVariants = () => {
    return {
        type: REQUEST_VARIANTS,
    }
}

const requestAvailableConfigurationSymptoms = () => {
    return {
        type: REQUEST_AVAILABLE_CONFIGURATION_SYMPTOMS,
    }
}

const receiveAttributes = (attributes) => {
    return {
        type: RECEIVE_ATTRIBUTES,
        attributes: attributes,
    }
}

const receiveVariants = (variants) => {
    return {
        type: RECEIVE_VARIANTS,
        variants: variants,
    }
}

const receiveAvailableConfigurationSymptoms = (availableConfigurationSymptoms) => {
    return {
        type: RECEIVE_AVAILABLE_CONFIGURATION_SYMPTOMS,
        availableConfigurationSymptoms: availableConfigurationSymptoms,
    }
}

const setAssetConfigurableAttributeType = (code, property, value) => {
    return {
        type: SET_ASSET_CONFIGURABLE_ATTRIBUTE,
        code: code,
        property: property,
        value: value,
    }
}

const setAssetAttributeType = (key, value) => {
    return {
        type: SET_ASSET_ATTRIBUTE,
        key: key,
        value: value,
    }
}

const requestAsset = () => {
    return {
        type: REQUEST_ASSET,
    }
}

const receiveAsset = (asset) => {
    return {
        type: RECEIVE_ASSET,
        asset: asset,
    }
}

const requestSubmitAsset = () => {
    return {
        type: REQUEST_SUBMIT_ASSET,
    }
}

const receiveSubmitAsset = (asset) => {
    return {
        type: RECEIVE_SUBMIT_ASSET,
        asset: asset,
    }
}

const receiveError = (error) => {
    return {
        type: RECEIVE_ERROR,
        error: error,
    }
}

export const requestFleetsHierarchy = () => {
    return {
        type: REQUEST_FLEETS_HIERARCHY,
    }
}

export const receiveFleetsHierarchy = (fleets) => {
    return {
        type: RECEIVE_FLEETS_HIERARCHY,
        fleets: fleets,
    }
}

export const requestAssets = () => {
    return {
        type: REQUEST_ASSETS,
    }
}

export const receiveAssets = (assets) => {
    return {
        type: RECEIVE_ASSETS,
        assets: assets,
    }
}

export const clearState = () => {
    return {
        type: CLEAR_STATE,
    }
}

const generalReceiveType = () => {
    return {
        type: GENERAL_RECEIVE,
    }
}

export const setConfigurationSymptom = (id, value) => {
    return {
        type: SET_CONFIGURATION_SYMPTOM,
        id: id,
        value: value,
    }
}
